import { render, staticRenderFns } from "./MyStory.vue?vue&type=template&id=99efbd3c&"
import script from "./MyStory.vue?vue&type=script&lang=js&"
export * from "./MyStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports